import $ from 'jquery';
import carousels from '../framework/carousel';

// Init carousel
$('.card_carousel').each((index, element) => {
  var i = 0;
  var carousel = $(element).find('.carousel-wrapper').first();
  var cardTitles = $(carousel).find('.label_fields').data('card-titles');

  if (cardTitles) {
    $(element)
      .find('.nav__text.nav__text__prev')
      .html(cardTitles[cardTitles.length - 1]);
    $(element).find('.nav__text.nav__text__next').html(cardTitles[1]);
  }

  var autoplay = $(carousel).data('autoplay');
  var autoplaySpeed = Number($(carousel).data('autoplay-speed'));
  var carousel = carousels(carousel, {
    autoplay: autoplay,
    dots: true,
    rows: 0,
    infinite: true,
    arrows: false,
    autoplaySpeed: autoplaySpeed,
    centerMode: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: false
        }
      }
    ]
  });

  //target the card container that has the theme styling applied to it
  const cardContainer = $(element).find('.themed__carousel-fd');
  // determine what theme is being applied
  const themeClass = cardContainer.hasClass('theme__dark') ? 'theme__dark' : 'theme__light';
  // find the slick dot element housing the next and prev slides and apply the theme class
  const slickDots = $(element).find('.slick-dots');
  slickDots.addClass(themeClass);


  $(element)
    .find('.carousel-nav__item--prev')
    .on('click', function () {
      carousel.prev();
    });
  $(element)
    .find('.carousel-nav__item--next')
    .on('click', function () {
      carousel.next();
    });

  //style only next slide
  const nextIndex = $(element).find('.slick-current').data('slick-index') + 1;
  const nextSlide = $(element).find(
    '.slick-slide[data-slick-index="' + nextIndex + '"]'
  );
  nextSlide.addClass('slick-slide--next');

  //same as above with previous
  const prevIndex = $(element).find('.slick-current').data('slick-index') - 1;
  const prevSlide = $(element).find(
    '.slick-slide[data-slick-index="' + prevIndex + '"]'
  );
  prevSlide.addClass('slick-slide--prev');

  $(element).on('beforeChange', function (event, slick, currentSlide) {
    //remove the next class from slides
    $(this).find('.slick-slide--next').removeClass('slick-slide--next');

    //remove the prev class from slides
    $(this).find('.slick-slide--prev').removeClass('slick-slide--prev');
  });

  $(element).on('afterChange', function (event, slick, currentSlide) {
    //get the next slide number and add class
    const nextIndex = currentSlide + 1;
    const nextSlide = $(this).find(
      '.slick-slide[data-slick-index="' + nextIndex + '"]'
    );
    nextSlide.addClass('slick-slide--next');

    //get prev slide number and add class
    const prevIndex = currentSlide - 1;
    const prevSlide = $(this).find(
      '.slick-slide[data-slick-index="' + prevIndex + '"]'
    );
    prevSlide.addClass('slick-slide--prev');

    // set before and after labels
    let labelBefore = '';
    let labelAfter = '';

    labelBefore = cardTitles[currentSlide - 1];
    labelAfter = cardTitles[currentSlide + 1];

    if (currentSlide === 0) {
      labelBefore = cardTitles[cardTitles.length - 1];
    } else if (currentSlide === cardTitles.length - 1) {
      labelAfter = cardTitles[0];
    }

    $(this).find('.nav__text.nav__text__prev').html(labelBefore);
    $(this).find('.nav__text.nav__text__next').html(labelAfter);
  });
});
